const security = {
    ru: {
        form: {
            firstname: 'Your first name',
            lastname: 'Your last name',
            email: 'Your email address',
            password: 'Choose a password',
            repeatPassword: 'Confirm password',
            signup: 'Sign up',
            next: 'Next',
            sendingEmail: 'Sending confirmation email...',
            confirmationSent: 'Confirmation email sent',
            completedRegistration:
                "It' done ! Now you can validate your account by clicking the link inside the email (check spam box...)",
            rememberme: 'Remember me',
            signup1: "No account yet ? Let's ",
            signup2: 'sign up',
            lostpassword: 'Lost password ?',
            send: 'Modify password',
            signin: 'Sign in'
        },
        validation: {
            name: 'Required and min 2 characters',
            email: 'Required and should look like a email address...',
            password: 'Min 6 characters',
            repeatPassword: 'Should with like the one above...'
        },
        request: {
            send: 'Reset password',
            sent: 'An email has been sent to reset your password'
        },
        error: {
            wrongLofin: 'Wrong email of password, try again !',
            serverError:
                "Error server side, it's not your fault, we are on it !"
        },
        message: {
            redirection: 'You are going to be redirected to login page',
            activated: 'Your account is now activated'
        }
    },
    fr: {
        form: {
            firstname: 'Votre prénom',
            lastname: 'Votre nom',
            email: 'Adresse courriel',
            password: 'Saisir un mot de passe',
            repeatPassword: 'Confirmation du mot de passe',
            signup: "S'inscrire",
            lostpassword: 'Mot de passe perdu ?',
            next: 'Suivant',
            sendingEmail: 'Envoie du courriel de confirmation...',
            confirmationSent: 'Courriel de confirmation envoyé',
            completedRegistration:
                "C'est fini ! Il ne vous reste plus qu'à valider votre compte en cliquant sur le lien dans le courriel envoyé ! (vérifiez dossier spam...)",
            rememberme: 'Se souvenir de moi',
            signup1: 'Pas encore de compte ? Venez vous ',
            signup2: 'inscrire',
            send: 'Modifier le mot de passe',
            signin: 'Se connecter'
        },
        validation: {
            name: 'Obligatoire et mini deux lettres',
            email: 'Obligatoire et doit ressembler à une adresse courriel...',
            password: 'Mini 6 charactères',
            repeatPassword: "Supposé être exactement le même qu'au dessus..."
        },
        request: {
            send: 'Réinitialiser mot de passe',
            sent:
                'Un courriel vous a été envoyé pour réinitialiser vitre mot de passe'
        },
        error: {
            wrongLofin:
                'Mauvaise adresse courriel ou mauvais mot de passe, réessayez !',
            serverError: 'Erreur de notre côté, on essaye de corriger !'
        },
        message: {
            redirection: 'Vous allez être redirigé vers la page de connexion',
            activated: 'Vote compte est maintenant activé'
        }
    }
}

export default security
